import { sb6, sb7, sb8, vj6, vj7, vj8, vj9, vk4 } from './football'
import {
  shadoElite,
  shadoEliteClosed,
  shadoEliteFullClosed,
  vaporElite,
  catchersGear,
} from './baseball'

export const productTypes: any = {
  SB6: sb6,
  SB7: sb7,
  SB8: sb8,
  VJ6: vj6,
  VJ7: vj7,
  VJ8: vj8,
  VJ9: vj9,
  VK4: vk4,

  //Fielding Glove to support older orders
  'Fielding Glove': shadoElite,
  //newly added products
  'Shado Elite Custom 1': shadoElite,
  'Shado Elite Custom 2': shadoElite,
  'Shado Elite Custom 3': shadoElite,
  'Shado Elite Custom 4': shadoElite,
  'Shado Elite Generic': shadoElite,
  'Shado Elite Shagger': shadoElite,
  'Shado Elite Custom - Closed Back': shadoEliteClosed,
  'Shado Elite Custom - Full Closed Back': shadoEliteFullClosed,
  'Vapor Elite Custom 1': vaporElite,
  'Vapor Elite Custom 2': vaporElite,
  'Vapor Elite Custom 3': vaporElite,
  'Vapor Elite Custom 4': vaporElite,
  'Vapor Elite Generic': vaporElite,
  'Vapor Elite Shagger': vaporElite,
  'Chest Protector': catchersGear,
  'Leg Guard': catchersGear,
}
